<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_INVENTORY_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh mục kho</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="addWarehouse"
          v-if="dataPermission.includes('CNPS_DEVICE_INVENTORY_CREATE')"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới kho
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="addWarehouseAgency"
          v-if="dataPermission.includes('CNPS_DEVICE_INVENTORY_AGENCY_CREATE')"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới kho đại lý
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel()">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm()">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian tạo </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37 text-search"
              @keyup.enter="submitForm()"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.levels"
              :options="listLevel"
              :settings="{ placeholder: 'Cấp kho' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regions"
              :options="listRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.managerId"
              :options="dataStaff"
              placeholder="Quản lý kho"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.keeperId" :options="dataStaff" placeholder="Thủ kho"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.type"
              :options="typeWarehouse"
              placeholder="Loại kho"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.state" :options="dataState" placeholder="Trạng thái"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.channel"
              :options="[
                { id: 'NGAN_LUONG', text: 'Ngân Lượng' },
                { id: 'VIMO', text: 'Vimo' },
              ]"
              placeholder="Kênh bán hàng"
            ></Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            Tổng kho: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              responsive
              hover
              :items="dataInventory"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(level)="data">
                {{ data.item.level | transformData(listLevel) }}
              </template>
              <template #cell(region)="data">
                <div v-for="(itemm, index) in data.item.regions" :key="index">
                  {{ itemm | transformData(listRegion) }}
                </div>
              </template>
              <template #cell(manager)="data">
                <p>
                  {{ data.item.managerInfo ? data.item.managerInfo.name : '' }}
                </p>
                <p>
                  {{ data.item.managerInfo ? data.item.managerInfo.email : '' }}
                </p>
              </template>
              <template #cell(channel)="{ item }">
                <p>
                  {{ item.channel | channelName }}
                </p>
              </template>
              <template #cell(quantity)="data">
                <p>
                  {{ data.item.quantity !== null ? data.item.quantity : 0 }}
                </p>
              </template>
              <template #cell(stockQuantity)="data">
                <p>
                  {{ data.item.stockQuantity !== null ? data.item.stockQuantity : 0 }}
                </p>
              </template>
              <template #cell(keeper)="data">
                <p>
                  {{ data.item.keeperInfo ? data.item.keeperInfo.name : '' }}
                </p>
                <p>
                  {{ data.item.keeperInfo ? data.item.keeperInfo.email : '' }}
                </p>
              </template>
              <template #cell(creator)="data">
                <p>
                  {{ data.item.creatorInfo ? data.item.creatorInfo.name : '' }}
                </p>
                <p>
                  {{ data.item.creatorInfo ? data.item.creatorInfo.email : '' }}
                </p>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Tạo:</b>
                  {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.dateModified">
                  <b>Cập nhật:</b>
                  {{ data.item.dateModified | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.state ? data.item.state : '']">
                  {{ data.item.state | transformData(dataState) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button class="dropdown-item" @click="toDetail(data.item)">
                    <span>&nbsp;</span>Chi tiết
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item.state === 'ACTIVE' &&
                      data.item.level !== 'EMPLOYEE' &&
                      (dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE') ||
                        dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE_BANK_INVENTORY'))
                    "
                    @click="editWarehouse(data.item)"
                  >
                    <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item.state === 'ACTIVE' &&
                      data.item.level === 'EMPLOYEE' &&
                      dataPermission.includes('CNPS_DEVICE_INVENTORY_EMPLOYEE_UPDATE')
                    "
                    @click="editWarehouse(data.item)"
                  >
                    <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item.state === 'ACTIVE' &&
                      dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE') &&
                      data.item.level !== 'EMPLOYEE'
                    "
                    @click="lockWarehouse(data.item, 'LOCK')"
                  >
                    <i class="bx bx-lock-alt"></i><span>&nbsp;</span>Khoá
                  </button>
                  <button
                    v-if="
                      data.item.state === 'LOCK' &&
                      dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE') &&
                      data.item.level !== 'EMPLOYEE'
                    "
                    class="dropdown-item"
                    @click="lockWarehouse(data.item, 'ACTIVE')"
                  >
                    <i class="bx bx-lock-open-alt"></i><span>&nbsp;</span>Mở khoá
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>

    <!-- Modal thông báo -->
    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <!-- <b-button variant="outline-secondary" @click="close()">x</b-button> -->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import catWareMixin from './catWareMixin.js'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã kho' },
    { key: 'level', label: 'Cấp kho' },
    { key: 'name', label: 'Tên kho' },
    { key: 'channel', label: 'Kênh bán hàng' },
    { key: 'quantity', label: 'Tổng thiết bị', class: 'text-center' },
    { key: 'stockQuantity', label: 'Tổng TB tồn kho', class: 'text-center' },
    { key: 'address', label: 'Địa chỉ' },
    { key: 'region', label: 'Vùng kinh doanh', thStyle: 'min-width: 160px' },
    { key: 'city', label: 'Tỉnh/Thành phố', thStyle: 'min-width: 160px' },
    { key: 'manager', label: 'Quản lý kho' },
    { key: 'keeper', label: 'Thủ kho' },
    { key: 'creator', label: 'Người tạo' },
    { key: 'time', label: 'Thời gian' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin, catWareMixin],
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        fieldsTable,
        filterTable: fieldsTable,
        dataStaff: [],
        dataInventory: [],
        loading: false,
        showLoading: false,
        typeWarehouse: [{ id: 0, text: 'Tất cả' }, ...Config.typeWarehouse],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
          channel: '',
        },
        pagination: {
          total: 0,
        },
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        listLevel: Config.levelWarehouse,
        listRegion: [],
        dataProvince: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        hasDefaultFilter: true,
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.listStaff()
      this.getRegions()
      this.transformDate()
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
      channelName(value) {
        const mapName = {
          NGAN_LUONG: 'Ngân Lượng',
          VIMO: 'Vimo',
        }
        return mapName[value] || value
      },
    },
    methods: {
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      async listStaff() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.dataStaff = data.data.map(e => {
            return { id: e.userId, text: `${e.name} - ${e.userName}` }
          })
          this.dataStaff.unshift({ id: '0', text: 'Tất cả' })
        } catch (error) {
          console.log(error)
        }
      },

      toDetail(item) {
        window.open(`/cat-warehouse/${item.id}`, '_blank')
      },

      addWarehouse() {
        this.$router.push({ path: '/cat-warehouse-add' })
      },
      addWarehouseAgency() {
        this.$router.push({ path: '/cat-warehouse-add-agency' })
      },
      editWarehouse(item) {
        if (item.level !== 'EMPLOYEE') {
          window.open(`/cat-warehouse/edit/${item.id}`, '_blank')
        } else {
          window.open(`/cat-warehouse/edit-employee/${item.id}`, '_blank')
        }
      },

      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },

      async submitForm(event) {
        event.preventDefault()
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          channel: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.hasDefaultFilter = false
        this.fetchData()
      },

      async fetchData() {
        try {
          this.loading = true
          if (this.search.regions === '0' || this.search.regions == null) {
            delete this.search.regions
          } else {
            if (typeof this.search.regions === 'string') {
              this.search.regions = [this.search.regions]
            }
          }
          if (this.search.cityCode === '0') delete this.search.cityCode
          if (this.search.managerId === '0') delete this.search.managerId
          if (this.search.keeperId === '0') delete this.search.keeperId
          if (this.search.state === '0') delete this.search.state
          if (this.search.type === '0') delete this.search.type
          if (this.search.channel === '0' || !this.search.channel) delete this.search.channel
          const response = await DeviceService.getListWarehouse(this.search)
          if (response.code === 1000) {
            this.dataInventory = response.data.inventoryList || []
            this.pagination.total = response.data.count ? response.data.count : 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async getRegions() {
        const dataRes = await StaffService.getListRegions()
        if (dataRes.data.length > 0) {
          this.listRegion = dataRes.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.listRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },

      async exportExcel() {
        try {
          this.showLoading = true
          const req = { ...this.search }
          delete req.page
          delete req.limit
          await DeviceService.exportExcel(req)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async lockWarehouse(item, typeAction) {
        try {
          this.showLoading = true
          const response = await DeviceService.actionWarehouse({
            action: typeAction,
            id: item.id,
          })
          this.showLoading = false
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = typeAction === 'LOCK' ? 'Khoá thành công' : 'Mở khoá thành công'
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  @import './catWare.css';

  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
